import { Stack, Typography } from '@mui/material';

import { TRANSFER_TAX_KIND_DISPLAY_NAME } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsForm.constants';
import { DispositiveProvisionsFormRecipient } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsForm.types';
import {
  getDistributionSummary,
  useRecipientIdMetadataMap,
} from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsFormRecipients/DraggableListItemRecipient.utils';
import { RecipientNotesBadge } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsFormRecipients/RecipientNotesBadge';
import { DispositiveProvisionTileIcon } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/components/DispositiveProvisionTileIcon';
import { useSemanticTileKindNode } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/hooks/useSemanticTileKindNode';
import { COLORS } from '@/styles/tokens/colors';

interface PrimaryClientDeathSectionTemplateRecipientProps {
  recipient: DispositiveProvisionsFormRecipient;
}

export function PrimaryClientDeathSectionTemplateRecipient({
  recipient,
}: PrimaryClientDeathSectionTemplateRecipientProps) {
  const recipientIdToMetadata = useRecipientIdMetadataMap();

  const semanticTileKindNode = useSemanticTileKindNode({
    recipientKind: recipient?.recipientKind,
    recipientId: recipient?.recipientId ?? '',
  });

  return (
    <Stack direction="row" py={2} gap={2} alignItems="center">
      <DispositiveProvisionTileIcon
        size="large"
        variant="subtle"
        node={semanticTileKindNode}
      />
      <Stack direction="column" flexGrow={1}>
        <Typography variant="title-s" color={COLORS.NAVY['700']}>
          {recipientIdToMetadata[recipient?.recipientId ?? '']?.displayName ??
            'Recipient'}
        </Typography>
        <Typography variant="body-xs" color={COLORS.GRAY['500']}>
          {(recipient.transferTaxKind &&
            TRANSFER_TAX_KIND_DISPLAY_NAME[recipient.transferTaxKind]) ??
            undefined}
        </Typography>
        <Typography variant="body-xs" color={COLORS.GRAY['500']}>
          {getDistributionSummary(recipient)}
        </Typography>
      </Stack>
      <Stack>
        {recipient.notes && <RecipientNotesBadge notes={recipient.notes} />}
      </Stack>
    </Stack>
  );
}
